import { render, staticRenderFns } from "./light-sources.vue-select.vue?vue&type=template&id=f107cfd2&"
import script from "./light-sources.vue-select.vue?vue&type=script&lang=ts&"
export * from "./light-sources.vue-select.vue?vue&type=script&lang=ts&"
import style0 from "./light-sources.vue-select.vue?vue&type=style&index=0&id=f107cfd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports